import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';

export default function useApplicationProposalsQuery() {
  const { showError } = useError();
  const { error } = useSmartlook();
  return useQuery<ClientApplicationProposals>({
    queryKey: ['client', 'application', 'proposals'],
    queryFn: async () => {
      try {
        const resp = await fetchData('/client/application/proposals', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        });

        return resp;
      } catch (e) {
        error(
          '[useApplicationProposalsQuery][GET /client/application/proposals]',
          e,
        );
        showError();
        throw e;
      }
    },
  });
}

type ClientApplicationProposals = {
  bestOfferProposal: {
    amount: number;
    term: number;
  };
};
